import * as wuiUtils from './wuiUtils'
import * as so from './so'
import * as mandate from './mandate'
import * as rtMepsMakerUtil from './rtMepsMaker'
import * as rtCbft from './rtCbft'
import * as rtIaft from './rtIaftMaker'
import * as bulkMepsMakerUtil from './bulkMepsMaker'
import * as workList from './workList'
import * as onholdUtil from './onhold'
import * as bulkCmm from './bulkCmm'
import * as viewPymntFile from './viewPymntFile'

const allFunctions = {
        ...wuiUtils,
        ...so,
        ...mandate,
        ...rtMepsMakerUtil,
        ...rtCbft,
        ...rtIaft,
        ...bulkMepsMakerUtil,
        ...workList,
        ...onholdUtil,
        ...bulkCmm,
        ...viewPymntFile
}

export function getMethod(methodName) {
        const fn = allFunctions[methodName];
        return fn;
}